// extracted by mini-css-extract-plugin
export var standard = "Paragraph-module--standard--2vs01";
export var light = "Paragraph-module--light--3wUMN";